export default "__VITE_ASSET__BEF_wnU8__"